/**
 *
 * @module entry
 * @desc {SDK.Services.Device} entry point.
 *
 */

import DeviceClient from './deviceClient';
import DeviceClientConfiguration from './deviceClientConfiguration';
import DeviceClientEndpoint from './deviceClientEndpoint';
import DeviceMetadata from './deviceMetadata';

/**
 *
 * @typedef SDK.Services.Device
 * @type {Object}
 *
 * @property {DeviceClient} DeviceClient
 * @property {DeviceClientConfiguration} DeviceClientConfiguration
 * @property {DeviceClientEndpoint} DeviceClientEndpoint
 * @property {DeviceMetadata} DeviceMetadata
 *
 */

/**
 *
 * @type {SDK.Services.Device}
 *
 */
export default {

    DeviceClient,
    DeviceClientConfiguration,
    DeviceClientEndpoint,
    DeviceMetadata

};



// WEBPACK FOOTER //
// ./src/services/device/entry.js